import { render, staticRenderFns } from "./WeetBlockerPlayer.vue?vue&type=template&id=65d7965b&scoped=true"
import script from "./WeetBlockerPlayer.vue?vue&type=script&lang=ts"
export * from "./WeetBlockerPlayer.vue?vue&type=script&lang=ts"
import style0 from "./WeetBlockerPlayer.vue?vue&type=style&index=0&id=65d7965b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d7965b",
  null
  
)

export default component.exports